document.addEventListener('DOMContentLoaded', () => {
	const createSlider = (root) => {
		const track = root.querySelector('[data-slider-track]');
		if (!track) return;

		const itemSel = root.dataset.sliderItem || '.review-card, .game-card';
		const withActive = root.hasAttribute('data-slider-active');
		const AUTOPLAY = parseInt(root.dataset.sliderAutoplay, 10) || 3000;
		const DURATION = 600;

		const originals = [...track.querySelectorAll(itemSel)];
		const count = originals.length;
		if (!count) return;

		let visible = 0, slides = [], index = 0, busy = false, timer = null;

		const getVisible = () => parseInt(getComputedStyle(root).getPropertyValue('--slider-visible'), 10) || 1;
		const stop = () => { clearInterval(timer); timer = null; };
		const start = () => { stop(); timer = setInterval(next, AUTOPLAY); };

		const build = () => {
			track.querySelectorAll('[data-clone]').forEach(el => el.remove());
			for (let i = 0; i < visible; i++) {
				const c = originals[i % count].cloneNode(true);
				c.dataset.clone = '';
				c.setAttribute('aria-hidden', 'true');
				track.appendChild(c);
			}
			slides = [...track.querySelectorAll(itemSel)];
			slides.forEach(s => {
				s.addEventListener('mouseenter', stop);
				s.addEventListener('mouseleave', start);
			});
		};

		const step = () => slides.length < 2 ? slides[0].offsetWidth : slides[1].offsetLeft - slides[0].offsetLeft;

		const render = (animate = true) => {
			if (!animate) slides.forEach(s => s.style.transition = 'none');
			track.style.transition = animate ? '' : 'none';
			track.style.transform = `translate3d(${-index * step()}px,0,0)`;
			if (withActive) {
				const center = index + (visible >> 1);
				const last = index + visible - 1;
				slides.forEach((s, i) => {
					s.classList.toggle('review-card--active', i === center);
					s.classList.toggle('review-card--edge-left', i === index);
					s.classList.toggle('review-card--edge-right', i === last);
				});
			}
			if (!animate) {
				void track.offsetHeight;
				track.style.transition = '';
				slides.forEach(s => s.style.transition = '');
			}
		};

		function next() {
			if (busy) return;
			busy = true;
			index++;
			render();
			setTimeout(() => {
				if (index >= count) { index = 0; render(false); }
				busy = false;
			}, DURATION);
		}

		const prev = () => {
			if (busy) return;
			busy = true;
			if (index <= 0) {
				index = count;
				render(false);
				requestAnimationFrame(() => requestAnimationFrame(() => {
					index--; render();
					setTimeout(() => busy = false, DURATION);
				}));
				return;
			}
			index--;
			render();
			setTimeout(() => busy = false, DURATION);
		};

		const bind = (sel, fn) => {
			const el = root.querySelector(sel);
			if (el) el.addEventListener('click', () => { fn(); start(); });
		};
		bind('[data-slider-prev]', prev);
		bind('[data-slider-next]', next);

		let resizeT;
		window.addEventListener('resize', () => {
			clearTimeout(resizeT);
			resizeT = setTimeout(() => {
				const v = getVisible();
				if (v !== visible) {
					visible = v; build();
					if (index >= count) index = 0;
				}
				render(false);
			}, 150);
		});

		visible = getVisible();
		build();
		render(false);
		start();
	};

	document.querySelectorAll('[data-slider]').forEach(createSlider);
});
